import React, { Fragment, useEffect, useState } from 'react';
import { Card, ListGroup, Badge } from 'react-bootstrap';
import { Clock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Loading from '../../components/loading';
import ErrorMessage from '../../components/errorMessage';
import { useHomeAppointments } from '../hooks/useHomeAppointments';

const STATUS_CONFIG = {
  CONFIRMED: { label: 'Confirmada', bg: 'success' },
  CONFIRMED_BY_PATIENT: { label: 'Confirmada', bg: 'success' },
  SCHEDULED: { label: 'Não confirmada', bg: 'warning' },
  REARRANGED: { label: 'Reagendada', bg: 'warning' },
  PERFORMED: { label: 'Realizada', bg: 'secondary' },
  NO_SHOW: { label: 'Faltou', bg: 'danger' },
};

const DEFAULT_STATUS_CONFIG = { label: 'Não confirmada', bg: 'warning' };

const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return 'Bom dia';
  if (hour < 18) return 'Boa tarde';
  return 'Boa noite';
};

export default function TodayAgenda() {
  const navigate = useNavigate();

  const userDisplayName = sessionStorage.getItem('userDisplayName');

  const { appointments, isLoading, error } = useHomeAppointments();
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  useEffect(() => {
    if (error) {
      setShowErrorMessage(true);
    }
  }, [error]);

  return (
    <Card data-cy="today-agenda-card" className="rounded-4 shadow-lg border-0">
      <Loading isToHidden={isLoading === false} />
      {showErrorMessage && (
        <ErrorMessage message={error} show={showErrorMessage} setShow={setShowErrorMessage} />
      )}

      <Card.Header className="border-0 py-3">
        <h5 className="mb-0 fw-bold text-muted">
          {getGreeting()}
          {userDisplayName ? `, ${userDisplayName}!` : '!'}
        </h5>
        <small className="text-muted">Essa é a agenda da clínica de hoje</small>
      </Card.Header>

      <div style={{ maxHeight: '28vh', overflowY: 'auto' }}>
        <ListGroup variant="flush">
          {appointments.map((appointment) => {
            const statusConfig = STATUS_CONFIG[appointment.status] ?? DEFAULT_STATUS_CONFIG;

            return (
              <Fragment key={appointment.id}>
                <ListGroup.Item
                  data-cy="today-agenda-item"
                  className="d-flex justify-content-between align-items-center py-3"
                >
                  <div className="d-flex align-items-center">
                    <Clock className="me-3 flex-shrink-0" size={20} />
                    <div>
                      <p className="mb-1 text-body">
                        <span className="fw-bold">
                          {appointment.time} — {appointment.patientName}
                        </span>
                      </p>
                      <small className="text-muted">
                        {[appointment.procedure, appointment.dentistName]
                          .filter(Boolean)
                          .join(' · ')}
                      </small>
                    </div>
                  </div>

                  <Badge bg={statusConfig.bg} pill>
                    {statusConfig.label}
                  </Badge>
                </ListGroup.Item>
              </Fragment>
            );
          })}
        </ListGroup>
      </div>

      <Card.Body className="text-center py-5" hidden={appointments.length > 0}>
        <p className="text-muted mb-0">Nenhum atendimento para hoje.</p>
      </Card.Body>

      <Card.Body className="text-end py-2">
        <small
          className="text-primary fw-bold"
          role="button"
          onClick={() => navigate('/agenda-router')}
        >
          Ver agenda completa
        </small>
      </Card.Body>
    </Card>
  );
}
